module.exports = __webpack_public_path__ + "static/media/stay-connected.9616698c.svg";